
import { createAsyncActionCreator, IAsyncActionCreator } from '../store/actions/createActionCreator';
import { layoutTypeFacet, availableLayoutsFacet, defaultLayoutFacet } from '../facets/ScopeFacets';
import { IItemCacheThunkAction, IItemCacheDispatch } from '../store/actions/ItemCacheActions';
import { resolveItems } from './getItems';
import { LayoutTypeFacet } from '../models/layouts/LayoutTypeFacet';
import { ISetDefaultLayoutPayload } from '../controls/itemsViewControl';

/**
 * @internal
 */
export interface IUpdateAvailableLayoutsPayload {
  layouts: {
    [layoutId: string]: boolean;
  };
  itemsScopeItemKey: string;
}

/**
 * @internal
 */
export const updateAvailableLayouts: IAsyncActionCreator<IUpdateAvailableLayoutsPayload, IItemCacheThunkAction<void>> =
  createAsyncActionCreator((
    payload: IUpdateAvailableLayoutsPayload
  ): IItemCacheThunkAction<void> => {
    const {
      layouts,
      itemsScopeItemKey
    } = payload;

    return (dispatch: IItemCacheDispatch) => {
      dispatch(resolveItems({
        items: {
          [itemsScopeItemKey]: availableLayoutsFacet.pack(layouts)
        }
      }));
    };
  });

/**
 * @public
 */
export interface ISwitchLayoutPayload {
  itemsScopeItemKey: string;
  layoutType: LayoutTypeFacet | undefined;
}

/**
 * @public
 */
export const switchLayout: IAsyncActionCreator<ISwitchLayoutPayload, IItemCacheThunkAction<void>> = createAsyncActionCreator((
  payload: ISwitchLayoutPayload
): IItemCacheThunkAction<void> => {
  const {
    itemsScopeItemKey,
    layoutType
  } = payload;

  return (dispatch: IItemCacheDispatch) => {
    dispatch(resolveItems({
      items: {
        [itemsScopeItemKey]: layoutTypeFacet.pack(layoutType)
      }
    }));
  };
});

/**
 * @beta
 */
export const setDefaultLayout: IAsyncActionCreator<ISetDefaultLayoutPayload, IItemCacheThunkAction<void>> = createAsyncActionCreator((
  payload: ISetDefaultLayoutPayload
): IItemCacheThunkAction<void> => {
  return (dispatch: IItemCacheDispatch) => {
    dispatch(resolveItems({
      items: {
        [payload.itemsScopeItemKey]: defaultLayoutFacet.pack(payload.layoutType)
      }
    }));
  };
});
